import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import VumbleCase from "../cases/Vumble/vumble"

const Vumble = () => (
    <Layout>
        <SEO title="Vumble | Ryan Luu" />
        <VumbleCase />
    </Layout>
)

export default Vumble